import {
  accountDescription,
  assetDescription,
  buildEntityDescriptions,
  declareCommentaryContext,
  describeEntity,
} from '@helios/comments'
import { Position } from '../model/positions.model'

export const positionCommentary = declareCommentaryContext<Position>()({
  fields: ['acctId', 'accountName', 'secIdentifier'],
  build: pos => ({
    accountId: pos.acctId?.toString(),
    assetId: pos.secIdentifier,
    entityDescriptions: buildEntityDescriptions([
      describeEntity(
        'account',
        pos.acctId,
        accountDescription({ accountName: pos.accountName }),
      ),
      describeEntity(
        'asset',
        pos.secIdentifier,
        assetDescription({ secIdentifier: pos.secIdentifier }),
      ),
    ]),
  }),
})
